<div class="header">
    <span>{{ label() }}</span>
</div>
